import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'td-copied',
  templateUrl: './td-copied.component.html',
  styleUrls: ['./td-copied.component.css']
})
export class TdCopiedComponent implements OnInit {

  constructor() { }

  @Input('data') data:any;
  @Input('dataThead') dataThead:any;
  @ViewChild('msg0') msg0!: ElementRef<HTMLElement>;

  @HostBinding('class.copy-content') copyContentClass = true;

  @HostBinding('attr.data-thead')
  get dataTheadAttr(): any {
    return this.dataThead;
  }

  ngOnInit(): void {
  }

  @HostListener('click')
  copyTableData(){
    navigator.clipboard.writeText(this.data ?? '');
    const msg = this.msg0?.nativeElement;
    if (!msg) return;

    msg.style.opacity = '1';
    setTimeout(() => {
      msg.style.opacity = '0';
    }, 500);
  }

}
